import React from "react";

/**
 * Componente SVG del icono de Google Drive con contorno
 * @param {number} size - Tamaño del icono en píxeles
 * @param {object} props - Props adicionales para el SVG
 */
export const GoogleDriveIcon = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 10l-6 10l-3 -5l6 -10z" />
    <path d="M9 15h12l-3 5h-12" />
    <path d="M15 15l-6 -10h6l6 10z" />
  </svg>
);
